export default "__VITE_ASSET__BbFZooDi__"